var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage1VideoCover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1077 1003",
    style: {
      enableBackground: "new 0 0 1077 1003"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.56;fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.42;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 501.5,
    x2: 1077,
    y2: 501.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6457A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7BB1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1040.2,1002.5H36.8C16.5,1002.5,0,986,0,965.7V37.3C0,17,16.5,0.5,36.8,0.5h1003.5c20.2,0,36.8,16.5,36.8,36.8 v928.5C1077,986,1060.5,1002.5,1040.2,1002.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M542.9,227.8c-151.3,0-274,122.7-274,274s122.7,274,274,274s274-122.7,274-274S694.2,227.8,542.9,227.8z  M542.9,708.8c-117.5,0-212.8-95.3-212.8-212.8s95.3-212.8,212.8-212.8S755.7,378.5,755.7,496S660.4,708.8,542.9,708.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M657.4,477.7l-168-97c-13.6-7.9-30.7,2-30.7,17.7v194c0,15.7,17,25.6,30.7,17.7l168-97 C671.1,505.2,671.1,485.5,657.4,477.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage1VideoCover);
export default __webpack_public_path__ + "static/media/stage1_videoCover.be9d5bdefab22ea608fcbffc3985830e.svg";
export { ForwardRef as ReactComponent };